const VectorCity = ({ className }: { className?: string }) => {
    return (
        <svg
            className={className}
            viewBox="0 0 400 150"
            preserveAspectRatio="none"
        >
            {/* --- Layer 1: Background Silhouette (Faded) --- */}
            <g opacity={0.5} fill="#121823ff">
                <path d="M0,150 L0,87 L40,87 L40,51 L90,51 L90,78 L130,78 L130,42 L170,42 L170,60 L220,60 L220,69 L280,69 L280,51 L340,51 L340,78 L400,78 L400,150 Z" />
            </g>

            {/* --- Layer 2: Middle/Foreground Buildings (Darker) --- */}
            <g fill="#0d141eff">
                {/* Building 1: Left tall */}
                <rect x="10" y="99" width="30" height="51" />
                {/* Building 2: Short wide */}
                <rect x="45" y="116" width="40" height="34" />
                {/* Building 3: Pointy skyscraper layer */}
                <path d="M100,150 L100,73.5 L130,73.5 L130,150 Z" />
                {/* Building 4: Center massive */}
                <rect x="140" y="90.5" width="50" height="59.5" />
                {/* Building 5: Right huge tower */}
                <rect x="210" y="65" width="40" height="85" />
                {/* Building 6: Short block */}
                <rect x="255" y="107.5" width="30" height="42.5" />
                {/* Building 7: Far right */}
                <rect x="300" y="82" width="40" height="68" />
                <rect x="350" y="99" width="40" height="51" />
            </g>

            {/* --- Windows (Yellow/White Lights) --- */}
            <g fill="#edf6c3ff" opacity="0.39">
                {/* Windows for B1 (10,99) (+9) */}
                <rect x="14" y="104" width="4" height="4" /> <rect x="24" y="104" width="4" height="4" />
                <rect x="14" y="114" width="4" height="4" /> <rect x="24" y="114" width="4" height="4" />
                <rect x="14" y="124" width="4" height="4" /> <rect x="24" y="124" width="4" height="4" />
                <rect x="14" y="134" width="4" height="4" /> <rect x="24" y="134" width="4" height="4" />

                {/* Windows for B2 (45,116) (+6) */}
                <rect x="48" y="121" width="20" height="4" />
                <rect x="48" y="131" width="20" height="4" />
                <rect x="48" y="141" width="20" height="4" />

                {/* Windows for B3 (100,150) (+13) */}
                <rect x="105" y="83" width="5" height="5" /> <rect x="115" y="83" width="5" height="5" />
                <rect x="105" y="103" width="5" height="5" /> <rect x="120" y="93" width="5" height="5" />
                <rect x="110" y="123" width="5" height="5" /> <rect x="120" y="133" width="5" height="5" />
                <rect x="105" y="143" width="5" height="5" />

                {/* Windows for B4 (140,90.5) (+10) */}
                <rect x="145" y="95" width="5" height="5" /> <rect x="155" y="95" width="5" height="5" /> <rect x="165" y="95" width="5" height="5" /> <rect x="175" y="95" width="5" height="5" />
                <rect x="145" y="110" width="5" height="5" /> <rect x="155" y="110" width="5" height="5" /> <rect x="165" y="110" width="5" height="5" /> <rect x="175" y="110" width="5" height="5" />
                <rect x="145" y="125" width="5" height="5" /> <rect x="155" y="125" width="5" height="5" /> <rect x="165" y="125" width="5" height="5" /> <rect x="175" y="125" width="5" height="5" />
                <rect x="145" y="140" width="5" height="5" /> <rect x="155" y="140" width="5" height="5" /> <rect x="165" y="140" width="5" height="5" /> <rect x="175" y="140" width="5" height="5" />

                {/* Windows for B5 (210,65) (+15, shortened) */}
                <rect x="215" y="70" width="4" height="75" opacity="0.5" />
                <rect x="225" y="70" width="4" height="75" opacity="0.5" />
                <rect x="235" y="70" width="4" height="75" opacity="0.5" />

                {/* Windows for B6 (255,107.5) (+7) */}
                <rect x="260" y="112" width="6" height="6" />
                <rect x="270" y="122" width="6" height="6" />
                <rect x="260" y="132" width="6" height="6" />
                <rect x="270" y="142" width="6" height="6" />

                {/* Windows for B7 (300,82) (+12) */}
                <rect x="305" y="87" width="4" height="4" /> <rect x="315" y="87" width="4" height="4" /> <rect x="325" y="87" width="4" height="4" />
                <rect x="305" y="97" width="4" height="4" /> <rect x="315" y="97" width="4" height="4" /> <rect x="325" y="97" width="4" height="4" />
                <rect x="305" y="107" width="4" height="4" /> <rect x="315" y="107" width="4" height="4" /> <rect x="325" y="107" width="4" height="4" />
                <rect x="305" y="117" width="4" height="4" /> <rect x="315" y="117" width="4" height="4" /> <rect x="325" y="117" width="4" height="4" />
                <rect x="305" y="127" width="4" height="4" /> <rect x="315" y="127" width="4" height="4" /> <rect x="325" y="127" width="4" height="4" />

                {/* Windows for B8 (350,99) (+9) */}
                <rect x="355" y="104" width="10" height="10" /> <rect x="375" y="104" width="10" height="10" />
                <rect x="355" y="124" width="10" height="10" /> <rect x="375" y="124" width="10" height="10" />
            </g>
        </svg>
    );
};

export default VectorCity;
